import _extends from "/data/node/node-server/flyme-web-admin/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SCHEMA_NOTICE_CATE, SCHEMA_NOTICE_DATA } from "~/assets/js/api";
import { getHeaders } from "~/assets/js/utils";
import axios from "axios";

export default {
  name: "notice",
  asyncData: function asyncData(_ref) {
    var route = _ref.route,
        redirect = _ref.redirect;

    return {
      searchValue: "",

      tableData: [],
      count: 0,
      maxNum: 10,
      nowPageNum: 1,

      cateData: [],
      machineArr: ["所有"],
      machine: "所有",
      versionArr: ["所有"],
      version: "所有",

      sortArr: [{ label: "是", value: 1 }, { label: "否", value: 0 }],

      reminder: "注：版本随着机型的选择而改变，当指定机型和版本不是“所有”时，才能新增数据。导入表格时务必注意不要导入重复数据！",

      dataLoading: false,
      showDialog: false,
      isUpdate: false,
      updateId: "",

      uploadExcelHeader: {},

      form: {
        name: "",
        desc: "",
        developer: "",
        status: "",
        model: "",
        sort: 0
      },
      rules: {
        name: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }],
        developer: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }],
        model: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "该值不能为空",
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    getNoticeCate: function getNoticeCate() {
      var _this2 = this;

      SCHEMA_NOTICE_CATE.select({
        headers: {
          "MZ-Query-Order": "createAt:-1",
          "MZ-Query-MaxNum": 1000,
          "MZ-Query-Count": true,
          "MZ-Token": this.$store.state.userInfo.token,
          "MZ-Uid": this.$store.state.userInfo.uid
        }
      }).then(function (res) {
        if (res.data.code === "000000") {
          _this2.cateData = res.data.data.values;
          var tempArr = [],
              flag = false;
          for (var i = 0, len = _this2.cateData.length; i < len; i++) {
            if (_this2.machineArr.indexOf(_this2.cateData[i].machine) == -1) _this2.machineArr.push(_this2.cateData[i].machine);
          }
        } else {
          var _this = _this2;
          _this2.$store.commit("openError", { obj: _this, res: res });
        }
      }, function (err) {
        var _this = _this2;
        _this2.$store.commit("openError", { obj: _this, res: err.response });
      });
    },
    selectGetList: function selectGetList() {
      this.nowPageNum = 1;
      this.getList();
    },
    getVersionList: function getVersionList() {
      var _this3 = this;

      this.versionArr = ["所有"];
      if (this.machine !== "所有") {
        {
          this.cateData.forEach(function (item) {
            if (item.machine === _this3.machine) _this3.versionArr.push(item.version);
          });
        }
      }
      this.version = "所有";
      this.nowPageNum = 1;
      this.getList();
    },
    searchGetList: function searchGetList() {
      this.nowPageNum = 1;
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;

      this.dataLoading = true;
      var where = {
        machine: this.machine,
        version: this.version
      };
      if (where.machine !== "所有") {
        where.machine = this.machine;
      } else {
        delete where.machine;
      }
      if (where.version !== "所有") {
        where.version = this.version;
      } else {
        delete where.version;
      }
      if (this.searchValue !== "") where.name = { $regex: this.searchValue };
      SCHEMA_NOTICE_DATA.select({
        where: where,
        headers: {
          "MZ-Query-NowPageNum": this.nowPageNum - 1,
          "MZ-Query-MaxNum": this.maxNum,
          "MZ-Query-Count": true,
          "MZ-Query-Order": "createAt:-1",
          "MZ-Token": this.$store.state.userInfo.token,
          "MZ-Uid": this.$store.state.userInfo.uid
        }
      }).then(function (res) {
        if (res.data.code === "000000") {
          _this4.count = res.data.extra.count;
          _this4.tableData = res.data.data.values;
          _this4.dataLoading = false;
        } else {
          var _this = _this4;
          _this4.$store.commit("openError", { obj: _this, res: res });
        }
      }, function (err) {
        var _this = _this4;
        _this4.$store.commit("openError", { obj: _this, res: err.response });
      });
    },
    addData: function addData() {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          SCHEMA_NOTICE_DATA.insert({
            object: _extends({}, _this5.form, {
              version: _this5.version,
              machine: _this5.machine
            }),
            headers: {
              "MZ-Token": _this5.$store.state.userInfo.token,
              "MZ-Uid": _this5.$store.state.userInfo.uid
            }
          }).then(function (res) {
            if (res.data.code === "000000") {
              _this5.$message({
                type: "success",
                message: "操作成功！"
              });
              _this5.getList();
            } else {
              var _this = _this5;
              _this5.$store.commit("openError", { obj: _this, res: res });
            }
            _this5.showDialog = false;
          }, function (err) {
            var _this = _this5;
            _this5.$store.commit("openError", {
              obj: _this,
              res: err.response
            });
            _this5.showDialog = false;
          });
        }
      });
    },
    updateData: function updateData() {
      var _this6 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var headers = getHeaders();
          axios.put("/updateNoticeData", _extends({
            "MZ-Token": _this6.$store.state.userInfo.token,
            "MZ-Uid": _this6.$store.state.userInfo.uid,
            "MZ-AppId": headers["MZ-AppId"],
            "MZ-Sign": headers["MZ-Sign"],
            objectId: _this6.updateId,
            schemaName: "notice_data"
          }, _this6.form)).then(function (res) {
            if (res.data.code === "000000") {
              _this6.$message({
                type: "success",
                message: "操作成功！"
              });
              _this6.getList();
            } else {
              var _this = _this6;
              _this6.$store.commit("openError", { obj: _this, res: res });
            }
            _this6.showDialog = false;
            _this6.isUpdate = false;
            _this6.updateId = "";
          }, function (err) {
            var _this = _this6;
            _this6.$store.commit("openError", {
              obj: _this,
              res: err.response
            });
            _this6.showDialog = false;
            _this6.isUpdate = false;
            _this6.updateId = "";
          });
        }
      });
    },
    next: function next() {
      this.isUpdate ? this.updateData() : this.addData();
    },
    openUpdateDialog: function openUpdateDialog(row) {
      this.isUpdate = true;
      this.showDialog = true;
      this.updateId = row._id;
      var name = row.name,
          desc = row.desc,
          developer = row.developer,
          status = row.status,
          version = row.version,
          machine = row.machine,
          sort = row.sort,
          model = row.model;

      this.form = {
        name: name,
        desc: desc,
        developer: developer,
        status: status,
        version: version,
        machine: machine,
        sort: sort,
        model: model
      };
    },
    deleteData: function deleteData(id) {
      var _this7 = this;

      this.$confirm("是否确定删除此项数据 ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var headers = getHeaders();
        axios.post("/deleteNoticeData", {
          "MZ-Token": _this7.$store.state.userInfo.token,
          "MZ-Uid": _this7.$store.state.userInfo.uid,
          "MZ-AppId": headers["MZ-AppId"],
          "MZ-Sign": headers["MZ-Sign"],
          schemaName: "notice_data",
          objectId: id
        }).then(function (res) {
          console.log(res);
          if (res && res.data && res.data.code === "000000") {
            _this7.$message({
              type: "success",
              message: "操作成功！"
            });
            _this7.getList();
          } else {
            var _this = _this7;
            _this7.$store.commit("openError", { obj: _this, res: res });
          }
        }, function (err) {
          var _this = _this7;
          _this7.$store.commit("openError", {
            obj: _this,
            res: err.response
          });
        });
      });
    },
    handleCurrentChange: function handleCurrentChange() {
      this.getList();
    },
    beforeUploadExcel: function beforeUploadExcel(file) {
      console.log(file.type);
      if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        var headers = getHeaders();
        this.uploadExcelHeader["MZ-AppId"] = headers["MZ-AppId"];
        this.uploadExcelHeader["MZ-Sign"] = headers["MZ-Sign"];
        this.uploadExcelHeader["MZ-Token"] = this.$store.state.userInfo.token;
        this.uploadExcelHeader["MZ-Uid"] = this.$store.state.userInfo.uid;
        this.uploadExcelHeader["schemaName"] = "notice_data";
        return true;
      } else {
        this.$message.error("请上传正确的Excel文件");
        return false;
      }
    },
    uploadExcelSuccess: function uploadExcelSuccess(res) {
      if (res && res.code === "000000") {
        this.$message({
          type: "success",
          message: "导入成功！"
        });
        this.getList();
      } else if (res && res.code === "000009") {
        this.$message.error("excel文件已存在，若要上传请修改文件名！");
      } else {
        this.$message.error("导入失败！");
      }
    },
    uploadExcelError: function uploadExcelError(err) {
      this.$message.error("导入失败！");
    }
  },
  mounted: function mounted() {
    this.getNoticeCate();
    this.getList();
  },

  watch: {
    showDialog: function showDialog(val) {
      if (val === false) {
        this.$refs.form.resetFields();
        this.isUpdate = false;
        this.updateId = "";
        this.form = {
          name: "",
          desc: "",
          developer: "",
          status: "",
          sort: 0,
          model: ""
        };
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/node/node-server/flyme-web-admin/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index/noticeData.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/node/node-server/flyme-web-admin/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index/noticeData.vue
// module chunks = 11